export default __webpack_public_path__ + "static/Entenda0133-56ec0a74587b83810248edc805f68d75.jpg";